import { atomFamily, selectorFamily } from "recoil"
import { myProfileSelectorFamily } from "src/recoil/selectors/organization/myProfile/myProfileSelectorFamily"

export const nicknameStateFamily = atomFamily<string | undefined, string>({
  key: "atoms/organization/myProfile/nicknameStateFamily",
  default: selectorFamily<string | undefined, string>({
    key: "atoms/organization/myProfile/nicknameStateFamily_default",
    get:
      (organizationId) =>
      ({ get }) => {
        const myProfile = get(myProfileSelectorFamily(organizationId))
        return myProfile?.nickname
      },
  }),
})
